import { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Loading } from '../../lib/components/atomic';

/** Told to the approvals screen when this window comes back from Swan. */
export const CONSENT_RETURN_MESSAGE = 'pxtra-card:consent-returned';

/**
 * Where Swan sends the manager after they sign.
 *
 * Nothing is read here: the cards are created at Swan and reach us through the
 * webhooks. This only hands the window back, so the manager returns to the list
 * they were working through instead of collecting dashboard tabs.
 */
export const CardConsentReturn = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.opener?.postMessage(CONSENT_RETURN_MESSAGE, window.location.origin);
    // Only a window that script opened may close itself; the approvals screen
    // opens this one, so this succeeds there and harmlessly does nothing if
    // the link was opened by hand.
    window.close();
  }, []);

  return (
    <Box className="flex flex-col items-center justify-center gap-2 py-16">
      <Loading />
      <Typography variant="body2" color="grey.600">
        {t('pxtraCard:consentReturn')}
      </Typography>
    </Box>
  );
};
